import { gql } from '@apollo/client';

export const FETCH_FILE_SYSTEM_OBJECT = gql`
    query fetchFileSystemObject($path: String) {
        facility {
            files(filter: { path: $path }) {
                name
                size
                isAFolder
                utcLastModifiedTime
                mimeType
                tags {
                    name
                    value
                }
                metaData {
                    name
                    value
                }
                uri
                storageClass
                isViewable
            }
        }
    }
`;
